<template>
    <div>
        <div class="row">
            <div class="col-sm-8 explain_big">
                <div class="position-fixed">
                    <div class="back">
                        <a href="/menu"><img src="/static/tutorial/back.png" alt=""></a>
                    </div>
                    <div class="nav">
                        <nav class="navbar navbar-expand-lg text-center" style="background-color:#F0F0F0; border:#A0A0A0 solid 1px; padding:10px; font-size:0.8rem; color:black;">
                            <div class="collapse navbar-collapse" id="navbarNavDropdown">
                                <ul class="navbar-nav">
                                    <li class="nav-item mr-3">
                                        <a class="hvr-grow" @click="indexChange(1)"><img :src="datas[1].img" alt=""><br>{{this.EventBus.getText("edit_menu_extrude")}}<span></span></a>
                                    </li>
                                    <li class="nav-item dropdown mr-2">
                                        <a class="hvr-grow dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <img :src="datas[2].img" alt=""><br>{{this.EventBus.getText("edit_menu_fillet")}}
                                        </a>
                                        <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                                        <a class="dropdown-item" @click="indexChange(2)"><img :src="datas[2].img" alt="" >{{this.EventBus.getText("edit_menu_fillet")}}</a>
                                        <a class="dropdown-item" @click="indexChange(3)"><img :src="datas[3].img" alt="" >{{this.EventBus.getText("edit_menu_chamfer")}}</a>
                                        </div>
                                    </li>
                                    <li class="nav-item dropdown mr-2">
                                        <a class="hvr-grow dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <img :src="datas[4].img" alt=""><br>{{this.EventBus.getText("edit_menu_revolve")}}
                                        </a>
                                        <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                                        <a class="dropdown-item" @click="indexChange(4)"><img :src="datas[4].img" alt="" >{{this.EventBus.getText("edit_menu_revolve")}}</a>
                                        <a class="dropdown-item" @click="indexChange(5)"><img :src="datas[5].img" alt="" >{{this.EventBus.getText("edit_menu_loft")}}</a>
                                        </div>
                                    </li>
                                    <li class="nav-item mr-3">
                                        <a class="hvr-grow"><img :src="datas[6].img" alt="" @click="indexChange(6)"><br>{{this.EventBus.getText("edit_menu_shell")}}</a>
                                    </li>
                                    <li class="nav-item mr-3">
                                        <a class="hvr-grow"><img :src="datas[7].img" alt="" @click="indexChange(7)"><br>{{this.EventBus.getText("edit_menu_offset")}}</a>
                                    </li>
                                    <li class="nav-item mr-3" style="border-left:0.5px solid; color:#C5C5C5">
                                    </li>
                                    <li class="nav-item mr-3">
                                        <a class="hvr-grow"><img :src="datas[8].img" alt="" @click="indexChange(8)"><br>{{this.EventBus.getText("edit_menu_union")}}</a>
                                    </li>
                                    <li class="nav-item mr-3">
                                        <a class="hvr-grow"><img :src="datas[9].img" alt="" @click="indexChange(9)"><br>{{this.EventBus.getText("edit_menu_subtract")}}</a>
                                    </li>
                                    <li class="nav-item mr-3">
                                        <a class="hvr-grow"><img :src="datas[10].img" alt="" @click="indexChange(10)"><br>{{this.EventBus.getText("edit_menu_intersect")}}</a>
                                    </li>
                                    <li class="nav-item mr-2">
                                        <a class="hvr-grow"><img :src="datas[11].img" alt="" @click="indexChange(11)"><br>{{this.EventBus.getText("edit_menu_merge")}}</a>
                                    </li>
                                    <li class="nav-item dropdown mr-2">
                                        <a class="hvr-grow dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <img :src="datas[12].img" alt="" ><br>{{this.EventBus.getText("edit_menu_slice")}}
                                        </a>
                                        <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                                        <a class="dropdown-item" @click="indexChange(12)"><img :src="datas[12].img" alt="">{{this.EventBus.getText("edit_menu_slice")}}</a>
                                        <a class="dropdown-item" @click="indexChange(13)"><img :src="datas[13].img" alt="">{{this.EventBus.getText("edit_menu_separate")}}</a>
                                        </div>
                                    </li>
                                    <li class="nav-item mr-3" style="border-left:0.5px solid; color:#C5C5C5">
                                    </li>
                                    <li class="nav-item mr-2">
                                        <a class="hvr-grow"><img :src="datas[14].img" alt="" @click="indexChange(14)"><br>{{this.EventBus.getText("edit_menu_moverotate")}}</a>
                                    </li>
                                    <li class="nav-item dropdown mr-2">
                                        <a class="hvr-grow dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <img :src="datas[15].img" alt="" ><br>{{this.EventBus.getText("edit_menu_ratioscale")}}
                                        </a>
                                        <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                                        <a class="dropdown-item" @click="indexChange(15)"><img :src="datas[15].img" alt="">{{this.EventBus.getText("edit_menu_ratioscale")}}</a>
                                        <a class="dropdown-item" @click="indexChange(16)"><img :src="datas[16].img" alt="">{{this.EventBus.getText("edit_menu_axisscale")}}</a>
                                        <a class="dropdown-item" @click="indexChange(17)"><img :src="datas[17].img" alt="">{{this.EventBus.getText("edit_menu_lengthscale")}}</a>
                                        </div>
                                    </li>
                                    <li class="nav-item dropdown">
                                        <a class="hvr-grow dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <img :src="datas[18].img" alt=""><br>{{this.EventBus.getText("edit_menu_patterncopy")}}
                                        </a>
                                        <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                                        <a class="dropdown-item" @click="indexChange(18)"><img :src="datas[18].img" alt="">{{this.EventBus.getText("edit_menu_patterncopy")}}</a>
                                        <a class="dropdown-item" @click="indexChange(19)"><img :src="datas[19].img" alt="">{{this.EventBus.getText("edit_menu_circlecopy")}}</a>
                                        <a class="dropdown-item" @click="indexChange(20)"><img :src="datas[20].img" alt="">{{this.EventBus.getText("edit_menu_mirrorcopy")}}</a>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </nav>
                    </div>
                    <img :src=datas[index].img alt="" style="height:100px">
                    <h1>{{datas[index].subject}}</h1>
                    <div class="explain_detail">
                        <p>{{datas[index].explain[0].ex1}}</p>
                        <p>{{datas[index].explain[0].ex2}}</p>
                        <div class="explain_order ml-2 ">
                            <p>{{datas[index].explain[0].ex3}}</p>
                            <p>{{datas[index].explain[0].ex4}}</p>
                            <p>{{datas[index].explain[0].ex5}}</p>
                            <p>{{datas[index].explain[0].ex6}}</p>
                        </div>
                    </div>
                    <div class="explain_button pt-5">
                        <button @click="prevButton()" :disabled='index == 0'>{{this.EventBus.getSystemText("previous")}}</button>
                        <button @click="nextButton()" :disabled='index == datas.length -1'>{{this.EventBus.getSystemText("next")}}</button>
                    </div>
                </div>

            </div>
            <div class="col-sm-4 explain_img">
                <div class="img_list w-100" v-for="data in 6" v-bind:key="data.index">
                    <img :src="datas[index].imgex[data-1]" alt="" style="width:100%">
                </div>
            </div>
        </div>
        
        <js/>
    </div>
</template>


<script>
import Edit from '../../assets/language/edit.json'
export default {
    beforeCreate() {
        this.EventBus.loadLanguage(Edit);
    },
    data() {
        return {
            subject: undefined,
            img: undefined,
            explain: [],
            index: 0,
            datas: [
                {
                    index: 0,
                    img: ' ',
                    subject:this.EventBus.getText("edit_edit"),
                    explain:
                        [
                            {
                                ex1: this.EventBus.getText("edit_edit_ex1"), 
                                ex2: this.EventBus.getText("edit_edit_ex2"), 
                                ex3: this.EventBus.getText("edit_edit_ex3"), 
                                ex4: this.EventBus.getText("edit_edit_ex4"),
                                ex5: this.EventBus.getText("edit_edit_ex5"), 
                                ex6: this.EventBus.getText("edit_edit_ex6")
                            },
                        ],
                    imgex: ['']
                },
                {
                    index: 1,
                    img: '/static/tutorial/2. 편집/1. 돌출.png',
                    subject:this.EventBus.getText("edit_extrude"),
                    explain:
                        [
                            {
                                ex1:this.EventBus.getText("edit_extrude_ex1"), 
                                ex2:this.EventBus.getText("edit_extrude_ex2"), 
                                ex3:this.EventBus.getText("edit_extrude_ex3"), 
                                ex4:this.EventBus.getText("edit_extrude_ex4"),
                                ex5:this.EventBus.getText("edit_extrude_ex5"), 
                                ex6:this.EventBus.getText("edit_extrude_ex6")
                            },
                        ],
                    imgex: [
                    '/static/tutorial/2. 편집/gif/Extrude01.gif',
                    '/static/tutorial/2. 편집/gif/Extrude02.gif',
                    '/static/tutorial/2. 편집/gif/Extrude03.gif',
                    '/static/tutorial/2. 편집/gif/Extrude04.gif',
                    ]
                },
                {
                    index: 2,
                    img: '/static/tutorial/2. 편집/2. 모깎기.png',
                    subject:this.EventBus.getText("edit_fillet"),
                    explain:
                        [
                            {
                                ex1: this.EventBus.getText("edit_fillet_ex1"),
                                ex2: this.EventBus.getText("edit_fillet_ex2"), 
                                ex3: this.EventBus.getText("edit_fillet_ex3"), 
                                ex4: this.EventBus.getText("edit_fillet_ex4"),
                                ex5: this.EventBus.getText("edit_fillet_ex5")
                            },
                        ],
                    imgex: ['/static/tutorial/2. 편집/gif/Fillet.gif']
                },
                {
                    index: 3,
                    img: '/static/tutorial/2. 편집/3. 모따기.png',
                    subject:this.EventBus.getText("edit_chamfer"),
                    explain:
                        [
                            {ex1: this.EventBus.getText("edit_chamfer_ex1"), 
                            ex2: this.EventBus.getText("edit_chamfer_ex2"), 
                            ex3: this.EventBus.getText("edit_chamfer_ex3"),
                            ex4: this.EventBus.getText("edit_chamfer_ex4"),
                            ex5: this.EventBus.getText("edit_chamfer_ex5")},
                        ],
                    imgex: ['/static/tutorial/2. 편집/gif/Chamfer.gif'] 
                },
                {
                    index: 4,
                    img: '/static/tutorial/2. 편집/4. 리볼브.png',
                    subject:this.EventBus.getText("edit_revolve"),

                    explain:
                        [
                            {ex1: this.EventBus.getText("edit_revolve_ex1"), 
                            ex2: this.EventBus.getText("edit_revolve_ex2"), 
                            ex3: this.EventBus.getText("edit_revolve_ex3"), 
                            ex4: this.EventBus.getText("edit_revolve_ex4"),
                            ex5: this.EventBus.getText("edit_revolve_ex5"), 
                            ex6: this.EventBus.getText("edit_revolve_ex6")},
                        ],
                    imgex: ['/static/tutorial/2. 편집/gif/Revolve.gif'] 
                },
                {
                    index: 5,
                    img: '/static/tutorial/2. 편집/5. 로프트.png',                    
                    subject:this.EventBus.getText("edit_loft"),
                    explain:
                        [
                            {ex1: this.EventBus.getText("edit_loft_ex1"), 
                            ex2: this.EventBus.getText("edit_loft_ex2"), 
                            ex3: this.EventBus.getText("edit_loft_ex3"),
                            ex4: this.EventBus.getText("edit_loft_ex4"),
                            ex5: this.EventBus.getText("edit_loft_ex5")},
                        ],
                    imgex: ['/static/tutorial/2. 편집/gif/Loft.gif'] 
                },
                {
                    index: 6,
                    img: '/static/tutorial/2. 편집/6. 쉘.png', 
                    subject:this.EventBus.getText("edit_shell"),
                    explain:
                        [
                            {ex1: this.EventBus.getText("edit_shell_ex1"), 
                            ex2: this.EventBus.getText("edit_shell_ex2"), 
                            ex3:this.EventBus.getText("edit_shell_ex3"), 
                            ex4: this.EventBus.getText("edit_shell_ex4"),
                            ex5:this.EventBus.getText("edit_shell_ex5")},
                        ],
                    imgex: ['/static/tutorial/2. 편집/gif/Shell.gif'] 
                },
                {
                    index: 7,
                    img: '/static/tutorial/2. 편집/7. 오프셋.png',
                    subject:this.EventBus.getText("edit_offset"),
                    explain:
                        [
                            {ex1: this.EventBus.getText("edit_offset_ex1"), 
                            ex2: this.EventBus.getText("edit_offset_ex2"), 
                            ex3: this.EventBus.getText("edit_offset_ex3"), 
                            ex4: this.EventBus.getText("edit_offset_ex4"),
                            ex5:this.EventBus.getText("edit_offset_ex5")}
                        ],
                    imgex: ['/static/tutorial/2. 편집/gif/Offset.gif'] 
                },
                {
                    index: 8,
                    img: '/static/tutorial/2. 편집/8. 합치기.png',
                    subject:this.EventBus.getText("edit_union"),
                    explain:
                        [
                            {ex1: this.EventBus.getText("edit_union_ex1"), 
                            ex2: this.EventBus.getText("edit_union_ex2"), 
                            ex3: this.EventBus.getText("edit_union_ex3"), 
                            ex4: this.EventBus.getText("edit_union_ex4"),
                            ex5:this.EventBus.getText("edit_union_ex5")}
                        ],
                    imgex: ['/static/tutorial/2. 편집/gif/Union.gif']  
                },
                {
                    index: 9,
                    img: '/static/tutorial/2. 편집/9. 빼기.png',
                    subject:this.EventBus.getText("edit_subtract"),
                    explain:
                        [
                            {ex1: this.EventBus.getText("edit_subtract_ex1"), 
                            ex2: this.EventBus.getText("edit_subtract_ex2"), 
                            ex3: this.EventBus.getText("edit_subtract_ex3"), 
                            ex4: this.EventBus.getText("edit_subtract_ex4"),
                            ex5:this.EventBus.getText("edit_subtract_ex5")}
                        ],
                    imgex: ['/static/tutorial/2. 편집/gif/Subtract.gif']  
                },
                {
                    index: 10,
                    img: '/static/tutorial/2. 편집/10. 교차영역.png',
                    subject:this.EventBus.getText("edit_intersect"),
                    explain:
                        [
                            {ex1: this.EventBus.getText("edit_intersect_ex1"), 
                            ex2: this.EventBus.getText("edit_intersect_ex2"), 
                            ex3: this.EventBus.getText("edit_intersect_ex3"), 
                            ex4: this.EventBus.getText("edit_intersect_ex4"),
                            ex5:this.EventBus.getText("edit_intersect_ex5")}
                        ],
                    imgex: ['/static/tutorial/2. 편집/gif/Intersect.gif']  
                },
                {
                    index: 11,
                    img: '/static/tutorial/2. 편집/11. 면합치기.png',
                    subject:this.EventBus.getText("edit_merge"),
                    explain:
                        [
                            {ex1: this.EventBus.getText("edit_merge_ex1"), 
                            ex2: this.EventBus.getText("edit_merge_ex2"), 
                            ex3: this.EventBus.getText("edit_merge_ex3"), 
                            ex4: this.EventBus.getText("edit_merge_ex4"),
                            ex5: this.EventBus.getText("edit_merge_ex5"), 
                            ex6: this.EventBus.getText("edit_merge_ex6")},
                        ],
                    imgex: ['/static/tutorial/2. 편집/gif/Merge.gif']  
                },
                {
                    index: 12,
                    img: '/static/tutorial/2. 편집/12. 모델 자르기.png',
                    subject:this.EventBus.getText("edit_slice"),
                    explain:
                        [
                            {ex1: this.EventBus.getText("edit_slice_ex1"), 
                            ex2: this.EventBus.getText("edit_slice_ex2"), 
                            ex3: this.EventBus.getText("edit_slice_ex3"), 
                            ex4: this.EventBus.getText("edit_slice_ex4"),
                            ex5:this.EventBus.getText("edit_slice_ex5")}
                        ],
                    imgex: ['/static/tutorial/2. 편집/gif/Cut.gif'] 
                },
                {
                    index: 13,
                    img: '/static/tutorial/2. 편집/13. 분리하기.png',
                    subject:this.EventBus.getText("edit_separate"),
                    explain:
                        [
                            {ex1: this.EventBus.getText("edit_separate_ex1"), 
                            ex2: this.EventBus.getText("edit_separate_ex2"), 
                            ex3: this.EventBus.getText("edit_separate_ex3"), 
                            ex4: this.EventBus.getText("edit_separate_ex4"),
                            ex5:this.EventBus.getText("edit_separate_ex5")}
                        ],
                    imgex: ['/static/tutorial/2. 편집/gif/.gif'] 
                },
                {
                    index: 14,
                    img: '/static/tutorial/2. 편집/14. 이동회전.png',
                    subject:this.EventBus.getText("edit_move"),
                    explain:
                        [
                            {ex1: this.EventBus.getText("edit_move_ex1"), 
                            ex2: this.EventBus.getText("edit_move_ex2"), 
                            ex3: this.EventBus.getText("edit_move_ex3"), 
                            ex4: this.EventBus.getText("edit_move_ex4"),
                            ex5: this.EventBus.getText("edit_move_ex5"), 
                            ex6: this.EventBus.getText("edit_move_ex6"),
                            ex7: this.EventBus.getText("edit_move_ex7")},
                        ],
                    imgex: ['/static/tutorial/2. 편집/gif/move-rotate.gif']
                },
                {
                    index: 15,
                    img: '/static/tutorial/2. 편집/15. 전체 비율.png',
                    subject:this.EventBus.getText("edit_scale"),
                    explain:
                        [
                            {ex1: this.EventBus.getText("edit_scale_ex1"), 
                            ex2: this.EventBus.getText("edit_scale_ex2"), 
                            ex3: this.EventBus.getText("edit_scale_ex3"), 
                            ex4: this.EventBus.getText("edit_scale_ex4"),
                            ex5: this.EventBus.getText("edit_scale_ex5"), 
                            ex6: this.EventBus.getText("edit_scale_ex6"),
                            ex7: this.EventBus.getText("edit_scale_ex7")},
                        ],
                    imgex: ['/static/tutorial/2. 편집/gif/ratio.gif']
                },
                {
                    index: 16,
                    img: '/static/tutorial/2. 편집/16. 축 비율.png',
                    subject:this.EventBus.getText("edit_axis"),
                    explain:
                        [
                            {ex1: this.EventBus.getText("edit_axis_ex1"), 
                            ex2: this.EventBus.getText("edit_axis_ex2"), 
                            ex3: this.EventBus.getText("edit_axis_ex3"), 
                            ex4: this.EventBus.getText("edit_axis_ex4"),
                            ex5: this.EventBus.getText("edit_axis_ex5"), 
                            ex6: this.EventBus.getText("edit_axis_ex6"),
                            ex7: this.EventBus.getText("edit_axis_ex7")},
                        ],
                    imgex: ['/static/tutorial/2. 편집/gif/axis.gif']
                },
                {
                    index: 17,
                    img: '/static/tutorial/2. 편집/17. 길이조절.png',
                    subject:this.EventBus.getText("edit_length"),
                    explain:
                        [
                            {ex1: this.EventBus.getText("edit_length_ex1"), 
                            ex2: this.EventBus.getText("edit_length_ex2"), 
                            ex3: this.EventBus.getText("edit_length_ex3"), 
                            ex4: this.EventBus.getText("edit_length_ex4"),
                            ex5:this.EventBus.getText("edit_length_ex5")}
                        ],
                    imgex: ['/static/tutorial/2. 편집/gif/Length.gif']
                },
                {
                    index: 18,
                    img: '/static/tutorial/2. 편집/18. 패턴 복제.png',
                    subject:this.EventBus.getText("edit_pattern"),
                    explain:
                        [
                            {ex1: this.EventBus.getText("edit_pattern_ex1"), 
                            ex2: this.EventBus.getText("edit_pattern_ex2"), 
                            ex3: this.EventBus.getText("edit_pattern_ex3"), 
                            ex4: this.EventBus.getText("edit_pattern_ex4"),
                            ex5:this.EventBus.getText("edit_pattern_ex5")}
                        ],
                    imgex: ['/static/tutorial/2. 편집/gif/Pattern copy.gif']
                },
                {
                    index: 19,
                    img: '/static/tutorial/2. 편집/19. 회전 복제.png',
                    subject:this.EventBus.getText("edit_circle"),
                    explain:
                        [
                            {ex1: this.EventBus.getText("edit_circle_ex1"), 
                            ex2: this.EventBus.getText("edit_circle_ex2"), 
                            ex3: this.EventBus.getText("edit_circle_ex3"), 
                            ex4: this.EventBus.getText("edit_circle_ex4"),
                            ex5:this.EventBus.getText("edit_circle_ex5")}
                        ],
                    imgex: ['/static/tutorial/2. 편집/gif/circle copy.gif'] 
                },
                {
                    index: 20,
                    img: '/static/tutorial/2. 편집/20. 대칭 복제.png',
                    subject:this.EventBus.getText("edit_mirror"),
                    explain:
                        [
                            {ex1: this.EventBus.getText("edit_mirror_ex1"), 
                            ex2: this.EventBus.getText("edit_mirror_ex2"), 
                            ex3: this.EventBus.getText("edit_mirror_ex3"), 
                            ex4: this.EventBus.getText("edit_mirror_ex4"),
                            ex5: this.EventBus.getText("edit_mirror_ex5"), 
                            ex6: this.EventBus.getText("edit_mirror_ex6")},
                        ],
                    imgex: ['/static/tutorial/2. 편집/gif/Mirror copy.gif']
                },
                
            ]
        } 
    },
    created() {
        this.push(this.index);
    },
    methods: {
        nextButton() {
            this.index = this.index + 1;
            window.scrollTo(0,0);
        },
        prevButton() {
            this.index = this.index - 1;
            window.scrollTo(0,0);
        },
        push(index) {
            this.subject =  this.datas[index].subject
            this.img = this.datas[index].img
            this.explain = [this.datas[index].explain[index].ex1, this.datas[index].explain[index].ex2, this.datas[index].explain[index].ex3, this.datas[index].explain[index].ex4, this.datas[index].explain[index].ex5, this.datas[index].explain[index].ex6]
            this.imgex = this.datas[index].imgex
        
        },
        indexChange(index){
            this.index = index;
            window.scrollTo(0,0);
        },
        myFunction() {
            document.getElementById("myDropdown").classList.toggle("show");
        },
        myFunction2() {
            document.getElementById("myDropdown2").classList.toggle("show");
        } 
    }
    
}
</script>

<style scoped>
    
    p {
        color: black;
    }
    .explain_big {
        padding: 0 8vw;
        margin-top: 8vw;
        float: left;
    }

    h1 {
        font-size: 25px;
        color: black;
        font-weight: 700;

    }

    .explain_detail p{
        padding: 0px;
        margin: 0px;

    }

    .explain_order p{
        margin: 0px;
        padding: 0px;
    }

    button{
        border-radius: 30px;
        padding: 3px 30px;
        margin: 10px;
        border-color: lightgray;
        border-style: solid;
        background-color: white;
        font-size: 0.8rem;
        outline: 0;
    }
    .explain_img {
        right: 0;
        width: 100%;
        padding-top: 150px;
        /* background-color: white; */
    }

    .explain_img img{
        width: 614.33px;
        /* height: auto; */
        /* height: 1080px; */
    }
    .img_list {
        float: right;
    }
    .back img{
        margin-left: -100px;
        width: 35px;
        height: 35px;
        box-shadow: none;
        display: flex;
        position: fixed;
    }
    
    .navBar img{
        display: flex;
        width: 100%;
        height: auto;
    }
    .nav-item{
        display: block;
        cursor: pointer;
    }

    .nav-item img{
        width: 35px;
        height: 35px;
        margin-bottom: 0.3vw;
    }

    .dropdown-menu img{
        width: 18px;
        height: 18px;
        margin-right: 10px;
    }
    .dropdown-menu a{
        font-size: 15px;
    }
    .nav{
        margin-bottom: 6vw;
    }
    a { color: inherit; } 

    .hvr-grow {
        margin: 8px;
        display: inline-block;
        vertical-align: middle;
        -webkit-transform: perspective(1px) translateZ(0);
        transform: perspective(1px) translateZ(0);
        box-shadow: 0 0 1px rgba(0, 0, 0, 0);
        -webkit-transition-duration: 0.3s;
        transition-duration: 0.3s;
        -webkit-transition-property: transform;
        transition-property: transform;
        }
        .hvr-grow:hover, .hvr-grow:focus, .hvr-grow:active {
        -webkit-transform: scale(1.1);
        transform: scale(1.2);
        }
</style>


// WEBPACK FOOTER //
// src/pages/tutorial_menu/edit_menu.vue